export function isDateValid(dates: (Date | string | undefined | null)[]): boolean {
  const container: boolean[] = [];

  dates.forEach((date) => {
    if (date !== undefined && date !== null) {
      const formattedDate = typeof date === 'object' ? date : new Date(date);
      container.push(formattedDate >= new Date(1900, 0, 1));
    }
  });

  return container.every((value) => value === true);
}

export function validateDates(values: any[] | undefined, property: string): boolean {
  const container = [];
  if (values) {
    for (const element of values) {
      container.push(element[property]);
    }
  }
  return !isDateValid(container);
}
